export const LOCATE_SUBSCRIBER = "locateSubscriber"
export const LOCATE_SUBSCRIBER_RESULT = "locateSubscriberResult"
export const SUBSCRIBER_DATA = "subscriberData"
